export default "__VITE_ASSET__Ca8EaN3g__"